/* eslint-disable no-param-reassign */
import { COLORS } from '@/shared/constants/colors'
import { STATUSES } from '@/shared/constants/communications'
import { auth, db, functions, firestore } from '@/shared/services/firebase'
import axiosIns from '@hw-core/libs/axios'

// eslint-disable-next-line consistent-return
export const fetchUserExists = async ({ state, city, role, status, areas }) => {
  try {
    let query = db.collection('users')

    if (status) {
      query = query.where('status', '==', status)
    }
    if (state) {
      query = query.where('address.state', '==', state)
    }
    if (city && city.length > 0) {
      const cities = city.map(item => item.toLowerCase())
      query = query.where('address.city', 'in', cities)
    }
    if (role) {
      query = query.where('role', '==', role)
    }

    const users = await query.get().then(snapshot => snapshot.docs.map(item =>
      ({
        id: item.id,
        firstName: item.data().firstName,
        fullName: item.data().fullName,
        mobile: item.data().mobile
      })
    ))

    if (areas && areas.length > 0) {
      const shiftsCollection = await firestore().collection('shifts').where('areaId', 'in', areas).get()
      const shifts = shiftsCollection.docs.map(item => ({...item.data(), id: item.id}))
      // eslint-disable-next-line consistent-return, array-callback-return
      const usersWorkedBefore = users.map(user => {
        // eslint-disable-next-line consistent-return, array-callback-return
        const hasWorkedInAreas = areas.map(areaId => {
          if (shifts.some(shift => shift.assignedTo === user.id && shift.areaId === areaId).length > 0) {
            return user
          }
        })

        if (hasWorkedInAreas.some(item => item !== undefined)) {
          return [...hasWorkedInAreas]
        }
      })

      // eslint-disable-next-line no-self-compare
      return usersWorkedBefore.filter(item => item !== undefined)
    }

    return users
  } catch (error) {
    throw new Error(error)
  }
}

export const saveMessageToDB = async ({ smsId, dataToUpdate }) => {
  try {
    if (smsId) {
      await db
        .collection('messages')
        .doc(smsId)
        .update({
          ...dataToUpdate,
          published: new Date(),
        })
      return smsId
    }

    const doc = await db.collection('messages').add({
      ...dataToUpdate,
      published: new Date(),
    })
    return doc.id
  } catch (error) {
    throw new Error(error)
  }
}

export const createUpdateSms = async ({ smsId, dataToUpdate, users }) => {
  try {
    const id = await saveMessageToDB({ smsId, dataToUpdate })
    if (dataToUpdate.status === 'sending') {
      const idToken = await auth.currentUser.getIdToken(true)
      await axiosIns.post(`${functions.url}/sendSmsForTargets`, {
        token: idToken,
        target: dataToUpdate.target,
        users,
        message: dataToUpdate.message,
        id,
      })
    }
    return
  } catch (error) {
    throw new Error(error)
  }
}

export const communicationStatusVariant = communication => {
  let variant = 'light-secondary'

  if (!communication.isDraft && communication.expirationDate) {
    const expiration = communication.expirationDate.toDate().getTime()
    const now = new Date().getTime()

    if (now <= expiration) variant = 'light-primary'
    else variant = 'light-danger'
  }

  return variant
}

export const communicationStatus = communication => {
  let status = STATUSES.DRAFT

  if (!communication.isDraft && communication.expirationDate) {
    const expiration = communication.expirationDate.toDate().getTime()
    const now = new Date().getTime()

    if (now <= expiration) status = STATUSES.ACTIVE
    else status = STATUSES.EXPIRED
  }

  return status
}

export const communicationTargetLabelsColor = index =>
  [COLORS.BLUE, COLORS.INDIGO, COLORS.RED, COLORS.YELLOW, COLORS.CYAN][index] || COLORS.GRAY
